import React from "react";
import "./seccion.css";

function Seccion({ sectionName, onSectionNameChange, onAddSection, loading }) {
  return (
    <div className="icfes-card">
      <p className="icfes-card-title">Crea una nueva seccion para tus preguntas</p>
      <label className="icfes-form-group">
        <span>Nombre de la seccion</span>
        <input
          type="text"
          placeholder="Nombre de la seccion"
          value={sectionName}
          onChange={(e) => onSectionNameChange(e.target.value)}
          className="icfes-input"
        />
      </label>
      <button
        type="button"
        className="icfes-button"
        disabled={loading}
        onClick={onAddSection}
      >
        {loading ? "Guardando..." : "Guardar seccion"}
      </button>
    </div>
  );
}

export default Seccion;
